import React from 'react'

import { SanityGallerySection } from '../../../graphql/gatsby'
import { useSanityRoleBasedContent } from '../../../lib/sanity/hooks/useSanityRoleBasedContent'
import { GalleryCollection } from './GalleryCollection'
import * as Styled from './styled'

export type GallerySectionProps = SanityGallerySection

const GallerySection: React.FC<GallerySectionProps> = ({
  title,
  collections,
  pageSectionStyles,
  roleBasedContent,
}) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })
  if (!shouldDisplay) {
    return null
  }
  return (
    <Styled.Container pageSectionStyles={pageSectionStyles}>
      {title && <Styled.Title>{title}</Styled.Title>}
      {collections?.map((collection, index) => (
        <GalleryCollection key={`${index}:${collection?.title}`} collection={collection} />
      ))}
    </Styled.Container>
  )
}

export default GallerySection
